module.exports = __webpack_public_path__ + "img/14400.18693c3d.jpg";